import { NewsModel } from "@/models";
import { newsPolicy } from "@/policies";
import { auth } from "@/services";

angular.module("app").controller("myNewsController", myNewsController);

myNewsController.$inject = ["$location", "News", "NewsApi", "Helpers"];

function myNewsController($location, News, NewsApi, Helpers) {
  const vm = this;
  const user = auth.user();
  const nowISO = window.moment().format(Helpers.isoFormat);

  // properties
  vm.filters = {
    page: 1,
    user_id: user.data.id,
  };

  vm.orderFilters = {
    ascending: {
      label: "Ascending",
      sort: "starts_at",
      order: "asc",
      starts_at_from: nowISO,
      ends_at_from: null,
    },
    descending: {
      label: "Descending",
      sort: "starts_at",
      order: "desc",
      starts_at_from: nowISO,
      ends_at_from: null,
    },
  };

  vm.selectedOrderFilter = vm.orderFilters.ascending;

  vm.news = [];
  vm.permissionChecks = {
    canCreate: newsPolicy.canCreate(user),
  };

  // methods
  vm.createNews = createNews;
  vm.orderNews = orderNews;
  vm.getNews = getNews;
  /**
   * Updates filters and refreshes the events.
   * Called by the order events select control.
   *
   * @return {void}
   */
  function orderNews() {
    angular.merge(vm.filters, vm.selectedOrderFilter);
    vm.filters.label = null;
    getNews();
  }
  /**
   * Initialises the controller.
   *
   * @returns {void}
   */
  function bootstrap(): void {
    // set inital filters from URL
    const urlParams = $location.search();
    if (Object.keys(urlParams).length) {
      vm.filters = {
        ...vm.filters,
        ...urlParams,
        page: urlParams.page ? parseFloat(urlParams.page) : 1,
      };
    }

    getNews();
  }

  /**
   * Shows the create news post modal
   *
   * @return {void}
   */
  function createNews() {
    News.manageNews().result.then((response) => {
      if (response.status === NewsModel.STATUS_APPROVED) {
        vm.news.data.unshift(response);
      }
    });
  }

  /**
   * Get and display news stories.
   * @return {void}
   */
  function getNews() {
    vm.isLoading = true;

    NewsApi.get(
      vm.filters,
      (response) => {
        vm.news = response;
        vm.isLoading = false;
      },
      (error) => {
        vm.isLoading = false;
      },
    );
  }

  bootstrap();
}
